import { createFileRoute } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { COMPARISONS } from "@/lib/comparisons-data";
import { buildSeoMeta } from "@/lib/seo";

export const Route = createFileRoute("/porownanie/")({
  head: () =>
    buildSeoMeta({
      title: "Porównania platform e-commerce — Baselinker, SellAsist, Shoper, ShopGold",
      description:
        "Szczegółowe porównania platform e-commerce 2026: Baselinker vs SellAsist, ShopGold vs Shoper, Shopify vs PrestaShop. Funkcje, ceny, rekomendacje.",
      path: "/porownanie",
    }),
  component: ComparisonIndex,
});

function ComparisonIndex() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-7xl px-6 pb-24 pt-32">
        <header className="mb-12 max-w-3xl">
          <span className="inline-block rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-primary">
            Porównania
          </span>
          <h1 className="mt-4 font-display text-4xl font-bold md:text-5xl">
            Która platforma e-commerce jest <span className="text-gradient">najlepsza dla Ciebie?</span>
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Praktyczne porównania największych systemów polskiego e-commerce. Konkretna rekomendacja po latach wdrożeń.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {COMPARISONS.map((c) => (
            <a
              key={c.slug}
              href={`/porownanie/${c.slug}`}
              className="group flex flex-col rounded-2xl border border-border bg-card p-6 transition hover:-translate-y-1 hover:border-primary hover:shadow-elegant"
            >
              <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider">
                <span className="rounded-full bg-primary/10 px-2 py-0.5 text-primary">{c.platformA.name}</span>
                <span className="text-muted-foreground">vs</span>
                <span className="rounded-full bg-primary-glow/10 px-2 py-0.5 text-primary">{c.platformB.name}</span>
              </div>
              <h3 className="mt-3 font-display text-lg font-bold leading-tight group-hover:text-primary">
                {c.title}
              </h3>
              <p className="mt-3 line-clamp-3 flex-1 text-sm text-muted-foreground">{c.excerpt}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary">
                Zobacz porównanie <ChevronRight className="h-3 w-3 transition group-hover:translate-x-1" />
              </div>
            </a>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
